import type {Language} from "../data/recipes/types";

export const MENU = '/';
export const RECIPES = '/recipes';
export const SCORE_COUNTER = '/score';
export const KITCHEN_TOOLS = '/kitchenTools';
export const DICE = '/Dice';
export const FART = '/Fart';

export const TEMP = '/Temp';
export const HOW_OLD = '/HowOld';
export const STOCKS = '/stocks.html';

export const ENGLISH: Language = 'EN';
export const ITALIAN: Language = 'IT';
export const POLISH: Language = 'PL';
export const EMPTY = '[EMPTY]';
export const SEARCHING_MESSAGE = 'Searching....';

// for local storage
export const LANGUAGE_RECIPE_KEY = 'currentLanguage';

export const MIDNIGHT_AS_24H_STRING = '00:00:00';

export const BRISCOLA = 'Briscola';
export const SCOPA = 'Scopa';

export const FLOUR = 'fl';
export const WATER = 'wt';
export const HYDRATION = 'hy';

export const INCREASE = 'increase';
export const DECREASE = 'decrease';

export const COOKING = 'cooking';


export const STEP1 = 'st1';
export const STEP2 = 'st2';
export const STEP3 = 'st3';
export const PLAYERS_SCORE = 'plscore';
export const PLAYER_NAMES = 'plnames';

export const PHONE = 'phone';
export const TABLET = 'tablet';
export const DESKTOP = 'desktop';

export const MAGIC_SEPARATOR = '•☽────✧˖°˖☆˖°˖✧────☾•';

export const DB_TIME_PATH = 'Casina/time'
export const DB_TEMP_PATH = 'Casina/temp'
export const DB_VOLTAGE_PATH = 'Casina/voltage'
